import React from "react";
import UniversalWorklistLayout from "./components/UniversalWorklistLayout";

interface AlertsPageProps {}

const AlertsPage = (props: AlertsPageProps) => {
  return (
    <UniversalWorklistLayout>
      <div className="text-center py-5">
        <i className="ti ti-alert-triangle fs-48 text-muted mb-3 d-block"></i>
        <h4 className="text-muted mb-2">No Alerts</h4>
        <p className="text-muted">There are currently no alerts to display.</p>
      </div>
    </UniversalWorklistLayout>
  );
};

export default AlertsPage;
